const Locale = {
    locales: {
        cs: 'cs-CZ',
        en: 'en-GB',
        hu: 'hu-HU',
        pl: 'pl-PL',
        ro: 'ro-RO',
        sk: 'sk-SK',
        xx: 'xx-XX',
    },
    getSupportedLocales: function() {
        return this.locales;
    },
    getDefaultLocale: function() {
        return this.locales.en;
    },
    getFallbackLocale: function() {
        return this.locales.xx;
    },
    getLocaleFromDOM: function() {
        return document.getElementById('zas-is-locale')?.getAttribute('data-locale') ?? '';
    },
    localeExists: function(locale) {
        return Object.keys(this.locales).find((language) => language.toLowerCase() === locale)?.toLowerCase() === locale;
    },
    getLocaleKeyBy: function (locale) {
        if (this.localeExists(locale)) {
            return this.locales[locale];
        }

        return null;
    },
    getLocale: function() {
        const domLocale = this.getLocaleFromDOM();

        if (!domLocale || !this.localeExists(domLocale)) {
            return this.getDefaultLocale();
        }

        return this.getLocaleKeyBy(domLocale);
    }
};

Object.freeze(Locale);
export default Locale;
